import {Component, inject, Renderer2} from '@angular/core';
import {EnvironmentService} from '../../services/environment.service';
import {UserCentricsService} from '../../services/user-centrics.service';

@Component({
  selector: 'cov-user-centrics',
  imports: [],
  templateUrl: './user-centrics.component.html',
  styleUrls: ['./user-centrics.component.scss'],
})
export class UserCentricsComponent {
  // SERVICE
  private renderer = inject(Renderer2);
  private environmentService = inject(EnvironmentService);
  private userCentricsService = inject(UserCentricsService);

  constructor() {
    this.loadUserCentricsLibrary();
  }

  // METHODS
  private loadUserCentricsLibrary() {
    const userCentricsEnvironment = this.environmentService.getUserCentricsEnvironment();
    const userCentricsLibrary = this.renderer.createElement('script');
    userCentricsLibrary.id = 'usercentrics-cmp';
    userCentricsLibrary.src = 'https://app.eu.usercentrics.eu/browser-ui/latest/loader.js';
    this.renderer.setAttribute(userCentricsLibrary, 'data-settings-id', userCentricsEnvironment);
    this.renderer.setAttribute(userCentricsLibrary, 'data-tcf-enabled', '');
    this.renderer.setAttribute(userCentricsLibrary, 'data-avoid-prefetch-services', '');
    this.renderer.setAttribute(userCentricsLibrary, 'data-eu-mode', 'true');

    userCentricsLibrary.async = true;

    window.addEventListener('UC_UI_INITIALIZED', this.onUserCentricsUiInitialized);
    this.renderer.appendChild(document.head, userCentricsLibrary);
  }

  private onUserCentricsUiInitialized = () => {
    const shadowHost = document.querySelector('#usercentrics-root');
    if (shadowHost && shadowHost.shadowRoot) {
      this.injectStyleIntoShadowDom(shadowHost.shadowRoot);
    }
    window.removeEventListener('UC_UI_INITIALIZED', this.onUserCentricsUiInitialized);
    this.userCentricsService.initialized.set(true);
  };

  private injectStyleIntoShadowDom(shadowRoot: ShadowRoot) {
    const style = document.createElement('style');
    style.textContent = `
      [data-testid="uc-privacy-button"] {
        left: 40px !important;
      }

      @media (max-width: 768px) {
        [data-testid="uc-privacy-button"] {
          bottom: 55px !important;
        }
      }
    `;
    shadowRoot.appendChild(style);
  }
}
